// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__4MEU6","canvas":"style_canvas__1nGvu","button":"style_button__FiU6y"};